import { css } from 'styled-components';

export const fontHeadingLg = css`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 800;
    font-size: 38px;
    line-height: 48px;

    letter-spacing: 1px;
`;

export const fontHeadingMd = css`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 800;
    font-size: 21px;
    line-height: 28px;

    letter-spacing: 0.5px;
`;

export const fontHeadingMdLight = css`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 21px;
    line-height: 28px;

    letter-spacing: 0.5px;
`;

export const fontHeadingSm = css`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 24px;

    letter-spacing: 0.5px;
`;

export const fontBodyLg = css`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 21px;
    line-height: 32px;
`;

export const fontBodyDefault = css`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
`;

export const fontBodySemiBold = css`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
`;

export const fontBodySm = css`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
`;
export const fontBodyXs = css`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
`;

export const fontButtonDefault = css`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 24px;

    letter-spacing: 0.75px;
`;
